import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { ShoppingBag } from "lucide-react";

export const ProductCard = ({ product }) => {
  const { addToCart } = useApp();
  const variants = product.variants || [];
  const hasMultiple = variants.length > 1;
  const basePrice = hasMultiple ? Math.min(...variants.map(v => v.price)) : product.price;

  return (
    <div
      className="group flex flex-col overflow-hidden rounded-2xl"
      style={{ background: "var(--bg-card)" }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.slug || product.id}`} className="block overflow-hidden aspect-[4/3]">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          loading="lazy"
        />
      </Link>
      <div className="p-5 md:p-6 flex flex-col items-center text-center gap-3">
        <Link to={`/product/${product.slug || product.id}`}>
          <h3 className="font-display text-xl md:text-2xl leading-tight" style={{ color: "var(--ink)" }}>
            {product.name}
          </h3>
        </Link>
        <p className="font-display text-lg" style={{ color: "var(--ink-soft)" }}>
          {hasMultiple && <span className="text-sm italic">from </span>}₹{Math.round(basePrice)}
        </p>
        {hasMultiple ? (
          <Link
            to={`/product/${product.slug || product.id}`}
            className="btn-primary mt-2 text-sm"
            style={{ padding: "0.6rem 1.4rem" }}
            data-testid={`choose-options-${product.id}`}
          >
            <ShoppingBag size={14} strokeWidth={1.5} /> Choose Options
          </Link>
        ) : (
          <button
            onClick={() => addToCart(product, 1)}
            aria-label="Add to cart"
            className="btn-primary mt-2 text-sm"
            style={{ padding: "0.6rem 1.4rem" }}
            data-testid={`add-to-cart-${product.id}`}
          >
            <ShoppingBag size={14} strokeWidth={1.5} /> Add to Cart
          </button>
        )}
      </div>
    </div>
  );
};
